import React from 'react';
import { Preset, ShadeColor, Text } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { find } from '../helpers';
import Category from './Category/Category';
import MainCategoryList from './MainCategoryList/MainCategoryList';
import * as S from './ContainerDesktop.styles';
export var ContainerDesktop = function (_a) {
    var _b;
    var campaignId = _a.campaignId, allCategories = _a.allCategories, selectedPath = _a.selectedPath, availableCategoriesSet = _a.availableCategoriesSet, selectedCategoriesSet = _a.selectedCategoriesSet, toggleSelection = _a.toggleSelection, closeFilterModal = _a.closeFilterModal;
    var categoryId = selectedPath.length > 1 && selectedPath[selectedPath.length - 2];
    // eslint-disable-next-line no-nested-ternary
    var category = categoryId
        ? find(allCategories, categoryId)
        : ((_b = allCategories === null || allCategories === void 0 ? void 0 : allCategories.categories) === null || _b === void 0 ? void 0 : _b.length) === 1
            ? allCategories.categories[0]
            : null;
    var categories = (category === null || category === void 0 ? void 0 : category.categories) || [];
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.Left, null,
            React.createElement(MainCategoryList, { selectedPath: selectedPath, allCategoriesForCampaign: allCategories, toggleSelection: toggleSelection, availableCategoriesSet: availableCategoriesSet, selectedCategoriesSet: selectedCategoriesSet })),
        React.createElement(S.Content, null, category ? (React.createElement(S.CategoriesWrapper, null, categories.map(function (item) { return (React.createElement(S.CategoryContainer, { key: item.id },
            React.createElement(Category, { key: item.id, category: item, campaignId: campaignId, toggleSelection: toggleSelection, availableCategoriesSet: availableCategoriesSet, selectedCategoriesSet: selectedCategoriesSet, closeFilterModal: closeFilterModal }))); }))) : (React.createElement(S.SelectCategoryWrapper, null,
            React.createElement(Text, { preset: Preset.XS, color: ShadeColor.dark60 },
                React.createElement(Translate, { message: "filters.selectCategory" })))))));
};
export default ContainerDesktop;
